interface QualityIndicatorProps {
  filledCount: number
  className?: string
}

export function QualityIndicator({ filledCount, className = '' }: QualityIndicatorProps) {
  const getLevel = () => {
    if (filledCount >= 5) return { level: 'high', label: 'Qualite elevee - resultats fiables', color: '#22C55E', segments: 3 }
    if (filledCount >= 3) return { level: 'medium', label: 'Qualite moyenne - resultats exploitables', color: '#F59E0B', segments: 2 }
    return { level: 'low', label: 'Qualite faible - resultats peu representatifs', color: '#EF4444', segments: 1 }
  }

  const { label, color, segments } = getLevel()

  return (
    <div className={`space-y-1.5 ${className}`}>
      <div className="flex gap-1">
        {[1, 2, 3].map((seg) => (
          <div
            key={seg}
            className="h-1.5 flex-1 rounded-full transition-all duration-300"
            style={{ backgroundColor: seg <= segments ? color : '#E2E4ED' }}
          />
        ))}
      </div>
      <p className="text-xs" style={{ color }}>{label}</p>
    </div>
  )
}
